import React from "react";
import { Button, Container, Nav, Row, Col, Badge, Card } from "react-bootstrap";
import AppComponent from "../../../Components/AppComponent";
import _ from "lodash";

import ItemList from "../../Components/ItemList";
import UnpActions from "../../../Stores/redux/UnPersist/Actions";
import PActions from "../../../Stores/redux/Persist/Actions";
import { connect } from "react-redux";
import api from "../../../Services/Api/api";
import { RecordTransactionHeadOffice } from "./RecordTransaction";
import NavBar from "../../Components/NavBar";
import { getFullName } from "../../../Modules/utils/fullname";
import RenderAmount, {
  RenderDenomination,
} from "../../../Components/etc/RenderAmount";
import DynamicFilters from "./DynamicFilters";
import TransactionDetails from "./TransactionDetails";
import { dtFrmtS1 } from "../../../Modules/utils/etc";
import DateRangeFilter from "../../Components/DateRangeFilter";
import { TRANSACTION_TYPES as ALL_TR_TYPES } from "./FormSteps/SelectTransactionType";

const SCREEN_NAME = "TRANSACTIONS_SCREEN";

const DENOMINATION_KEYS = [2000, 500, 200, 100, 50, 20, 10, 5, 2, 1];

export const TRANSACTION_TYPES = [
  {
    id: "office_expense",
    label: "Office Expense",
    color: "warning",
    desc: "Record daily office expenses like rent, fuel, or stationery",
  },

  {
    id: "user_payout",
    label: "Admin to FE",
    color: "info",
    desc: "Head-office paying to employee",
    renderLabel: (x) =>
      x?.salaryDetails?.baseSalary > 0
        ? "Salary"
        : x?.createdBy === x?.headOffice?._id
          ? "Admin to FE"
          : "Office to FE",
  },
  {
    id: "user_payin",
    label: "FE to Admin",
    color: "info",
    desc: "Employee paying to Head-office",
    renderLabel: (x) =>
      x?.createdBy === x?.headOffice?._id ? "FE to Admin" : "FE to Office",
  },
  {
    id: "owner_collection",
    label: "Owner Collection",
    color: "danger",
    desc: "Owner collecting daily cash from office",
  },
  // {
  //   id: "adjustment",
  //   label: "Adjustment",
  //   color: "secondary",
  //   desc: "Manual balance adjustment by admin or auditor",
  // },
];
const allowedTransactionTypes = TRANSACTION_TYPES.filter((x) =>
  ["office_expense", "user_payout", "user_payin"].includes(x.id),
);

const formatTypeLabel = (type, item) => {
  const trType =
    TRANSACTION_TYPES.find((x) => x.id === type) ||
    ALL_TR_TYPES.find((x) => x.id === type);

  return trType?.renderLabel?.(item) || trType?.label || type;
};

const ROW_CONFIG = {
  style: ({ index, item, total }) => {
    return total
      ? { fontWeight: "bold" }
      : item.status === "pending"
        ? { background: "#fff7c1" }
        : item.status === "rejected"
          ? { background: "#f9ac97ff" }
          : {};
  },
};

const COLUMN_CONFIG = {
  all: [
    {
      value: "sl",
      label: "Sl",
      render: ({ index }) => index + 1,
      renderTotal: () => "",
    },
    {
      value: "date",
      label: "Date",
      render: ({ item }) => dtFrmtS1(item.date),
      renderTotal: () => "Total",
    },
    {
      label: "Office",
      value: "office",
      render: ({ item }) => getFullName(item.office),
    },
    {
      value: "transactionType",
      label: "Type",
      render: ({ item }) => formatTypeLabel(item.transactionType, item),
    },

    {
      value: "agent",
      label: "Related User",
      render: ({ item }) => getFullName(item.relatedUser),
    },
    {
      value: "amount",
      label: "Amount",
      render: ({ item }) => <RenderAmount value={item.totalAmount} />,
    },
    {
      value: "transactionItem",
      label: "Category",
    },

    {
      value: "totalCod",
      label: "COD Amount",
      render: ({ item }) => <RenderAmount value={item.cod?.totalCOD} />,
    },
    {
      value: "codCurrent",
      label: "Balance Due (current)",
      render: ({ item }) => renderBalance(item.userBalanceDue?.current, "cod"),
    },
    {
      value: "codTotal",
      label: "Balance Due (total)",
      render: ({ item }) => renderBalance(item.userBalanceDue?.total, "cod"),
    },
    {
      value: "commCurrent",
      label: "Commission (cur)",
      render: ({ item }) =>
        renderBalance(item.commissionBalance?.current, "commission"),
    },
    {
      value: "commTotal",
      label: "Commission (total)",
      render: ({ item }) =>
        renderBalance(item.commissionBalance?.total, "commission"),
    },
    {
      value: "officeBalanceAfter",
      label: "Office Balance",
      render: ({ item }) =>
        renderBalance(item.officeBalance?.after?.totalAvailable),
    },
    {
      value: "status",
      label: "Status",
      render: ({ item }) => {
        const s = item.status;
        const map = {
          approved: { text: "", class: "text-success fw-bold" },
          pending: { text: "Pending", class: "text-warning fw-bold bg-black" },
          rejected: { text: "Rejected", class: "text-danger fw-bold" },
        };

        const v = map[s] || { text: s, class: "" };

        return <span className={v.class}>{v.text}</span>;
      },
    },
    {
      value: "note",
      label: "Note",
      render: ({ item }) => renderEditableNote(item),
      renderTotal: () => null,
    },
  ],

  office_expense: [
    {
      value: "sl",
      label: "Sl",
      render: ({ index }) => index + 1,
      renderTotal: () => "",
    },
    {
      value: "date",
      label: "Date",
      render: ({ item }) => dtFrmtS1(item.date),
      renderTotal: () => "Total",
    },
    {
      value: "transactionItem",
      label: "Category",
    },
    {
      value: "totalAmount",
      label: "Amount",
      render: ({ item }) => <RenderAmount value={item.totalAmount} />,
    },

    {
      value: "note",
      label: "Note",
      render: ({ item }) => renderEditableNote(item),
    },
  ],

  user_payout: [
    {
      value: "sl",
      label: "Sl",
      render: ({ index }) => index + 1,
      renderTotal: () => "Total",
    },
    {
      value: "date",
      label: "Date",
      render: ({ item }) => dtFrmtS1(item.date),
    },
    {
      value: "agent",
      label: "Employee",
      render: ({ item }) => getFullName(item.relatedUser),
    },
    {
      value: "totalAmount",
      label: "Pay Out",
      render: ({ item }) => <RenderAmount value={item.totalAmount} />,
    },
    {
      value: "codTotal",
      label: "Balance Due (total)",
      render: ({ item }) => renderBalance(item.userBalanceDue?.total, "cod"),
    },
    {
      label: "Office",
      value: "office",
      render: ({ item }) => getFullName(item.office),
    },
    {
      value: "note",
      label: "Note",
      render: ({ item }) => renderEditableNote(item),
    },
  ],

  owner_collection: [
    {
      value: "sl",
      label: "Sl",
      render: ({ index }) => index + 1,
      renderTotal: () => "",
    },
    {
      value: "date",
      label: "Date",
      render: ({ item }) => dtFrmtS1(item.date),
      renderTotal: () => "Total",
    },
    {
      label: "Office",
      value: "office",
      render: ({ item }) => getFullName(item.office),
    },
    {
      value: "totalCod",
      label: "Total COD",
      render: ({ item }) => (
        <RenderAmount value={item.meta?.overall?.totalCOD} />
      ),
    },
    {
      value: "totalAmount",
      label: "Amount",
      render: ({ item }) => (
        <RenderAmount style={{ color: "green" }} value={item.totalAmount} />
      ),
    },
    {
      value: "cash",
      label: "Cash",
      render: ({ item }) => (
        <RenderAmount value={item.totalAmountDetails?.cashAmount} />
      ),
    },
    {
      value: "online",
      label: "Online",
      render: ({ item }) => (
        <RenderAmount value={item.totalAmountDetails?.onlineAmount} />
      ),
    },

    {
      value: "status",
      label: "Status",
      render: ({ item }) => {
        const s = item.status;
        const map = {
          approved: { text: "Approved", class: "text-success fw-bold" },
          pending: { text: "Pending", class: "text-warning fw-bold" },
          rejected: { text: "Rejected", class: "text-danger fw-bold" },
        };

        const v = map[s] || { text: s, class: "" };

        return <span className={v.class}>{v.text}</span>;
      },
    },

    {
      value: "cashDenom",
      label: "Cash Denomination",
      render: ({ item }) => (
        <RenderDenomination
          denominations={item.totalAmountDetails?.cashDenominations}
        />
      ),
    },

    {
      value: "payin",
      label: "FE to Office",
      render: ({ item }) => (
        <RenderAmount
          style={{ color: "green" }}
          value={item.meta?.overall?.totalDepositsByFE}
        />
      ),
    },
    {
      value: "remain",
      label: "COD - FE_to_office",
      render: ({ item }) => (
        <RenderAmount
          value={
            item.meta?.overall?.totalCOD - item.meta?.overall?.totalDepositsByFE
          }
        />
      ),
    },
    {
      value: "payout",
      label: "Office to FE",
      render: ({ item }) => (
        <RenderAmount
          style={{ color: "red" }}
          value={item.meta?.overall?.totalPaidToFE}
        />
      ),
    },
    {
      value: "exp",
      label: "Office Expenses",
      render: ({ item }) => (
        <RenderAmount
          style={{ color: "red" }}
          value={item.meta?.officeExp?.totalOfficeExpenses}
        />
      ),
    },

    {
      value: "rtoLoss",
      label: "RTO Losses",
      render: ({ item }) => (
        <RenderAmount value={item.meta?.overall?.totalRtoLoss} />
      ),
    },
    {
      value: "userBalDUe",
      label: "User Balance Due",
      render: ({ item }) =>
        renderBalance(item.meta?.overall?.closingUserBalanceDue),
    },
    {
      value: "officeBalanceAfter",
      label: "Office Balance",
      render: ({ item }) =>
        renderBalance(item.officeBalance?.after?.totalAvailable),
    },
    {
      value: "note",
      label: "Note",
      render: ({ item }) => renderEditableNote(item),
    },
  ],
};

// ---------- Helpers (UI small utilities) ----------
function renderBalance(value, kind) {
  // undefined -> show dash
  if (typeof value === "undefined" || value === null)
    return <span className="text-muted">—</span>;

  const num = Number(value) || 0;
  const formatted = num.toLocaleString("en-IN");
  // For COD, positive means agent owes (show red). For commission, positive means payable to agent (green)
  if (kind === "cod") {
    return num > 0 ? (
      <span bg="danger">₹{formatted}</span>
    ) : (
      <span bg="success">₹{formatted}</span>
    );
  } else if (kind === "commission") {
    return num > 0 ? (
      <span bg="success">₹{formatted}</span>
    ) : (
      <span bg="danger">₹{formatted}</span>
    );
  }
  return <span>₹{formatted}</span>;
}

// note rendering uses closure handlers defined later; placeholders here to keep column defs readable
let _noteEditor = null;
function renderEditableNote(item) {
  // item may contain note string
  const note = item.note || "";
  // show small edit icon (unicode pencil) — clicking calls _noteEditor(item)
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
      <div style={{ flex: 1, whiteSpace: "nowrap" }}>
        {note || <span className="text-muted">—</span>}
      </div>
      <div
        style={{ cursor: "pointer" }}
        onClick={(e) => {
          e.stopPropagation();
          _noteEditor && _noteEditor(item);
        }}
      >
        <small className="text-primary">✎</small>
      </div>
    </div>
  );
}

// ---------- Component ----------
class TransactionsScreenOffice extends AppComponent {
  constructor(props) {
    super(props);

    this.state = {
      visibleModal: null,
      modalData: null,
      transactions: [],
      triggerReload: 0,
      query: {},
      additionalFilter: {
        transactionType: undefined,
      },
      deleting: false,
      approving: false,
      loadingAgents: false,
      offices: null,
    };

    this.additionalQueries = {
      where: {
        // $or: [
        //   { office: this.props.user._id },
        //   { relatedUser: this.props.user._id },
        //   { createdBy: this.props.user._id },
        //   { status: "pending" },
        // ],
      },
    };

    // bind note editor so renderEditableNote can call it
    _noteEditor = this.openNoteEditor.bind(this);
  }

  componentDidMount() {
    this.onMount();
    this.loadOffices();
  }

  async loadOffices() {
    try {
      this.setAsyncState({ loadingOffices: true });
      // Reuse head-office user endpoint for role=agent
      const res = await api.get("v1/head-office/user", {
        queryStr: JSON.stringify({ where: { role: "office" }, limit: 0 }),
      });
      const offices = res?.users || [];
      this.setAsyncState({ offices: [this.props.user, ...offices] });
    } catch (e) {
      this.setAsyncState({ error: e.message });
    } finally {
      this.setAsyncState({ loadingOffices: false });
    }
  }

  // fetch transactions from backend and map to current shape
  async retriveData(query) {
    // pass query directly to backend (ItemList handles stringify)
    const { transactions } = await api.get("v1/office/transaction", query);
    if (!Array.isArray(transactions)) return [];

    return transactions.map((item) => {
      // normalize agent/exposed fields for compatibility with older UI
      const normalized = {
        ...item,
        relatedUser: item.relatedUser || item.agent || null, // fallback
      };

      // compute RTO stats from rtoLossList (if present)
      const rtoList = item.rtoLossList || [];
      let rtoLossCount = 0,
        rtoLossAmount = 0;
      if (Array.isArray(rtoList)) {
        for (const r of rtoList) {
          const amt = parseFloat(r.amount) || 0;
          rtoLossCount += 1;
          rtoLossAmount += amt;
        }
      }

      return {
        ...normalized,
        // expose simpler rtoLoss shape for older columns
        rtoLoss: {
          total: { count: rtoLossCount, amount: rtoLossAmount },
        },
      };
    });
  }

  calculateTotal(items = []) {
    if (!items?.length) return null;

    const result = {
      totalAmount: 0,
      totalAmountDetails: {
        cashAmount: 0,
        onlineAmount: 0,
        cashDenominations: DENOMINATION_KEYS.reduce((acc, d) => {
          acc[d] = 0;
          return acc;
        }, {}),
      },
      meta: {
        overall: {
          totalCOD: 0,
          totalDepositsByFE: 0,
          totalPaidToFE: 0,
          totalRtoLoss: 0,
          closingUserBalanceDue: 0,
        },
        officeExp: {
          totalOfficeExpenses: 0,
        },
      },
      officeBalance: {
        after: {
          totalAvailable: 0,
        },
      },
    };

    for (const item of items) {
      if (item.status === "rejected") continue;

      const amount = Number(item.totalAmount || 0);

      const cashAmount = Number(item?.totalAmountDetails?.cashAmount || 0);
      const onlineAmount = Number(item?.totalAmountDetails?.onlineAmount || 0);
      const denomination = item?.totalAmountDetails?.cashDenominations;

      const totalCOD = Number(item?.meta?.overall?.totalCOD || 0);
      const totalDepositsByFE = Number(
        item?.meta?.overall?.totalDepositsByFE || 0,
      );
      const totalPaidToFE = Number(item?.meta?.overall?.totalPaidToFE || 0);
      const totalRtoLoss = Number(item?.meta?.overall?.totalRtoLoss || 0);
      const closingUserBalanceDue = Number(
        item?.meta?.overall?.closingUserBalanceDue || 0,
      );
      const totalOfficeExpenses = Number(
        item?.meta?.officeExp?.totalOfficeExpenses || 0,
      );
      const totalAvailable = Number(
        item?.officeBalance?.after?.totalAvailable || 0,
      );

      result.totalAmount += amount;
      result.totalAmountDetails.cashAmount += cashAmount;
      result.totalAmountDetails.onlineAmount += onlineAmount;

      result.meta.overall.totalCOD += totalCOD;
      result.meta.overall.totalDepositsByFE += totalDepositsByFE;
      result.meta.overall.totalPaidToFE += totalPaidToFE;
      result.meta.overall.totalRtoLoss += totalRtoLoss;
      result.meta.overall.closingUserBalanceDue += closingUserBalanceDue;
      result.meta.officeExp.totalOfficeExpenses += totalOfficeExpenses;
      result.officeBalance.after.totalAvailable += totalAvailable;

      if (denomination && Object.keys(denomination).length > 0) {
        // Use provided denomination
        for (const d of DENOMINATION_KEYS) {
          result.totalAmountDetails.cashDenominations[d] += Number(
            denomination[d] || 0,
          );
        }
      } else {
        // No denomination → treat entire amount as ₹1 notes
        result.totalAmountDetails.cashDenominations[1] += cashAmount;
      }
    }

    return result;
  }

  async setItems(items) {
    const total = this.calculateTotal(items);
    if (this.props.contentOnly)
      this.setAsyncState({ transactions: items, transactionTotal: total });
    else
      this.props.setScreenState({
        transactions: items,
        transactionTotal: total,
      });
  }

  getItems() {
    if (this.props.contentOnly) return this.state.transactions;
    else return this.props.transactions;
  }

  getTotal() {
    if (this.props.contentOnly) return this.state.transactionTotal;
    else return this.props.transactionTotal;
  }

  onNewTransaction(item) {
    // refresh list
    this.setAsyncState({
      triggerReload: Date.now(),
    });
    this.props.onNewTransaction?.(item);
  }

  handleRecordTransaction() {
    this.setAsyncState({
      visibleModal: "recordTransaction",
      modalData: {
        transaction: {
          transactionType: allowedTransactionTypes
            .map((x) => x.id)
            .includes(this.state.additionalFilter?.transactionType)
            ? this.state.additionalFilter?.transactionType
            : null,
        },
      },
    });
  }

  handleTypeChange(type) {
    this.setItems([]);
    this.setState((s) => ({
      additionalFilter: {
        ...(s.additionalFilter?.date ? { date: s.additionalFilter.date } : {}),
        ...(type === "all" ? {} : { transactionType: type }),
      },

      triggerReload: Date.now(),
    }));
  }

  async handleDelete(transaction) {
    try {
      if (this.state.deleting) return null;

      if (
        window.confirm(
          `Are you sure you want to delete this ${formatTypeLabel(
            transaction.transactionType,
            transaction,
          )} transaction ? This action is not reversible.`,
        )
      ) {
        this.setAsyncState({ deleting: true });
        await api.delete("v1/office/transaction/" + transaction._id);

        this.setAsyncState({
          visibleModal: null,
          modalData: null,
          triggerReload: Date.now(),
          deleting: false,
        });
      }
    } catch (e) {
      this.setAsyncState({ deleting: false });
      console.error(e.message);
      window.alert("Error deleting transaction: " + e.message);
    }
  }

  async handleApprove(transaction, flag) {
    const selectedStatus = flag
      ? { value: "approved", label: "Approve", verb: "approving" }
      : { value: "rejected", label: "Reject", verb: "rejecting" };

    try {
      if (this.state.approving) return null;

      if (
        window.confirm(
          `Are you sure you want to "${
            selectedStatus.label
          }" this "${formatTypeLabel(
            transaction.transactionType,
            transaction,
          )}" transaction ? This action is not reversible.`,
        )
      ) {
        this.setAsyncState({ approving: true });
        await api.patch(
          "v1/office/transaction/" + transaction._id + "/status",
          {
            status: selectedStatus.value,
          },
        );

        this.setAsyncState({
          visibleModal: null,
          modalData: null,
          triggerReload: Date.now(),
          approving: false,
        });
      }
    } catch (e) {
      this.setAsyncState({ approving: false });
      console.error(e.message);
      window.alert(`Error ${selectedStatus.verb} transaction: ${e.message}`);
    }
  }

  // ===== Inline Note Editor (quick flow) =====
  async openNoteEditor(transaction) {
    try {
      const currentNote = transaction?.note || "";
      const updated = window.prompt(
        `Edit note for transaction (${formatTypeLabel(
          transaction.transactionType,
          transaction,
        )}):`,
        currentNote,
      );
      // user pressed cancel
      if (updated === null) return;

      // If unchanged, no update
      if (updated === currentNote) return;

      // patch note
      await api.patch(`v1/office/transaction/${transaction._id}/note`, {
        note: updated,
      });

      // refresh
      this.setAsyncState({ triggerReload: Date.now() });
    } catch (err) {
      console.error("Note update failed:", err);
      window.alert("Failed to update note: " + (err.message || err));
    }
  }

  render() {
    const { visibleModal, modalData, triggerReload, additionalFilter } =
      this.state;

    const selectedType = this.state.additionalFilter?.transactionType || "all";
    const columns = COLUMN_CONFIG[selectedType] || COLUMN_CONFIG.all;

    const content = (
      <div>
        {/* Header */}
        <div className="pagetitlebar mb-3 d-flex justify-content-between align-items-center">
          <div className="left">
            <div className="title">Transactions</div>
          </div>

          <div className="right d-flex gap-2 align-items-center">
            <Button
              variant="secondary"
              onClick={() => this.setAsyncState({ triggerReload: Date.now() })}
            >
              Reload
            </Button>

            <Button
              onClick={() => this.handleRecordTransaction()}
              disabled={this.props.account?.closed}
            >
              {selectedType === "all" ||
              !allowedTransactionTypes.map((x) => x.id).includes(selectedType)
                ? "+ Record Transaction"
                : `+ Record ${formatTypeLabel(selectedType)}`}
            </Button>
          </div>
        </div>

        {/* Filters */}
        <DynamicFilters
          type={selectedType}
          values={additionalFilter}
          onChange={(f) =>
            this.setAsyncState({
              additionalFilter: { ...additionalFilter, ...f },
              triggerReload: Date.now(),
            })
          }
          isHeadOffice={true}
          agents={this.props.agents}
          offices={this.state.offices}
        />

        {/* Tabs */}
        <Nav
          variant="tabs"
          activeKey={selectedType}
          onSelect={(key) => this.handleTypeChange(key)}
          className="mb-3"
        >
          <Nav.Item key="all">
            <Nav.Link eventKey="all">All</Nav.Link>
          </Nav.Item>
          {TRANSACTION_TYPES.map((t) => (
            <Nav.Item key={t.id}>
              <Nav.Link eventKey={t.id}>{t.label}</Nav.Link>
            </Nav.Item>
          ))}
        </Nav>

        {/* Transactions List */}
        <ItemList
          defaultQuery={{
            populate: "relatedUser office headOffice",
            limit: 50,
            order: -1,
          }}
          query={this.state.query}
          additionalQueries={{
            ...(this.additionalQueries || {}),
            where: {
              ...(this.additionalQueries?.where || {}),
              ...(additionalFilter || {}),
            },
          }}
          triggerReload={triggerReload}
          items={this.getItems()}
          total={this.getTotal()}
          table={{
            rowConfig: ROW_CONFIG,
            columns: columns,
            onRowClick: ({ item, index }) =>
              this.setAsyncState({
                visibleModal: "transactionDetails",
                modalData: { transaction: item, index },
              }),
          }}
          retriveData={this.retriveData.bind(this)}
          setItems={this.setItems.bind(this)}
          scrollSelector={this.props.scrollSelector}
        />

        {/* Record Transaction Modal */}
        <RecordTransactionHeadOffice
          {...{
            key: `recordTransaction-${
              visibleModal === "recordTransaction"
                ? modalData?.transaction?._id?.toString() || "new"
                : "disabled"
            }`,
            allowedTransactionTypes,
            renderModal: true,
            visible: visibleModal === "recordTransaction",
            handleClose: () => this.setAsyncState({ visibleModal: null }),
            onSubmit: (item) => this.onNewTransaction(item),
            account: this.props.account,
            ...(modalData || {}),
          }}
        />

        {/* Transaction Details Modal */}
        <TransactionDetails
          {...{
            key: `transactionDetails-${
              visibleModal === "transactionDetails"
                ? modalData?.transaction?._id?.toString() || "new"
                : "disabled"
            }`,
            renderModal: true,
            visible: visibleModal === "transactionDetails",
            handleClose: () => this.setAsyncState({ visibleModal: null }),
            handleEdit: () =>
              this.setAsyncState({ visibleModal: "recordTransaction" }),
            ...(modalData || {}),
            handleDelete: () => this.handleDelete(modalData.transaction),
            handleApprove: (flag) =>
              this.handleApprove(modalData.transaction, flag),
            user: this.props.user,
          }}
        />
      </div>
    );

    if (this.props.contentOnly) {
      return content;
    }

    return (
      <>
        <NavBar activeLink="/transaction" />
        <Container className="gainner">{content}</Container>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  transactions: state.vState[SCREEN_NAME]?.transactions || [],
  transactionTotal: state.vState[SCREEN_NAME]?.transactionTotal,
  agents: state.vState.AGENTS_SCREEN?.agents,
  user: state.pState.user.user,
});

const mapDispatchToProps = (dispatch) => ({
  setScreenState: (obj, persist = false, screenName = SCREEN_NAME) =>
    persist
      ? dispatch(PActions.setPScreenState(screenName, obj))
      : dispatch(UnpActions.setVScreenState(screenName, obj)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TransactionsScreenOffice);
